<template>
  <Transition name="select-purchase-item-overlay">
    <div
      v-if="showItemTypeModal"
      class="select-purchase-item-modal-overlay select-purchase-item-modal-overlay--glass"
      @click.self="closeModal"
    >
      <Transition name="select-purchase-item-panel" appear>
        <div
          class="select-purchase-item-modal select-purchase-item-modal--glass"
          role="dialog"
          aria-labelledby="modal-title"
          @click.stop
        >
          <div class="select-purchase-item-modal-header select-purchase-item-modal-header--glass">
            <h2 id="modal-title" class="select-purchase-item-modal-title">
              <i class="bi bi-cart-plus select-purchase-item-modal-title__icon" aria-hidden="true"></i>
              Select Item Type
            </h2>
            <div class="select-purchase-item-modal-header-actions">
              <button
                type="button"
                class="select-purchase-item-icon-btn"
                aria-label="Help"
                title="Help"
                @click="showHelp"
              >
                <i class="bi bi-question-circle" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="select-purchase-item-icon-btn select-purchase-item-icon-btn--close"
                aria-label="Close"
                title="Close"
                @click="closeModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="select-purchase-item-modal-body select-purchase-item-modal-body--glass">
            <div class="select-purchase-item-options" role="radiogroup" aria-label="Purchase item type options">
              <label
                v-for="(option, index) in itemTypeOptions"
                :key="option.value"
                class="select-purchase-item-radio-option"
                :class="{
                  selected: selectedType === option.value,
                  [`select-purchase-item-radio-option--${index + 1}`]: true,
                }"
              >
                <input
                  type="radio"
                  v-model="selectedType"
                  :value="option.value"
                  name="purchaseItemType"
                />
                <div class="select-purchase-item-option-content">
                  <span class="select-purchase-item-radio-control" aria-hidden="true"></span>
                  <i v-if="option.icon" :class="option.icon" class="select-purchase-item-option-icon" aria-hidden="true"></i>
                  <span class="select-purchase-item-radio-label">{{ option.label }}</span>
                </div>
              </label>
            </div>
          </div>

          <div class="select-purchase-item-modal-footer select-purchase-item-modal-footer--glass">
            <SecondaryButton label="Cancel" icon="" @click="closeModal" />
            <PrimaryButton label="Continue" icon="bi bi-arrow-right" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import logger from '@/utils/logger';
import '../styles/SelectPurchaseItem.css';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'SelectPurchaseItem',
  components: { PrimaryButton, SecondaryButton },
  props: {
    modelValue: {
      type: String,
      default: 'Service Item',
    },
  },
  data() {
    return {
      selectedType: this.modelValue || 'Service Item',
      showItemTypeModal: true,
      itemTypeOptions: [
        { value: 'Service Item', label: 'Service Item', icon: 'bi bi-briefcase' },
        { value: 'Product Item', label: 'Product Item', icon: 'bi bi-box-seam' },
      ],
    };
  },
  watch: {
    modelValue(val) {
      this.selectedType = val;
    },
  },
  methods: {
    showHelp() {
      logger.log('Show help');
    },
    ok() {
      this.$emit('update:modelValue', this.selectedType);
      this.$emit('ok', this.selectedType);
      this.showItemTypeModal = false;
    },
    closeModal() {
      this.showItemTypeModal = false;
      this.$emit('close');
    },
  },
};
</script>
